<template>
  <div class="footer-container" v-if="mainData">
    <div class="footer-bg">
      <img class="footer-bg-img" src="/static/image/home/footer_bg.png" alt="" />
    </div>
    <div class="footer-inner">
      <!-- 3-Column Grid -->
      <div class="footer-grid">
        <!-- Brand -->
        <div class="footer-col footer-brand">
          <div class="brand-row">
            <img class="brand-logo" src="/static/image/home/logo.png" alt="百草健康" />
            <div class="brand-text">
              <span class="brand-cn">百草健康</span>
              <span class="brand-en">BAICAO HEALTH</span>
            </div>
          </div>
          <p class="brand-company">四川百草健康信息咨询有限公司</p>
          <p class="brand-info">
            公司地址：{{ mainData.address }}<br />
            联系电话：{{ mainData.phone }}<br />
            邮箱：{{ mainData.email }}
          </p>
        </div>

        <!-- Compliance -->
        <div class="footer-col footer-compliance">
          <!-- <h4 class="footer-heading">合规与政策</h4>
          <ul class="footer-links">
            <li><a href="#">用户协议</a></li>
            <li><a href="#">隐私政策</a></li>
            <li><a href="https://beian.miit.gov.cn/" target="_blank">ICP备案</a></li>
            <li><a href="#">资质合规</a></li>
          </ul> -->
        </div>

        <!-- QR Codes -->
        <div class="footer-col footer-qr">
          <div class="qr-row">
            <div class="qr-item">
              <div class="qr-box">
                <img src="/static/image/微信小程序码.png" class="qr-img" />
              </div>
              <span class="qr-label">微信公众号</span>
            </div>
            <div class="qr-item">
              <div class="qr-box">
                <img src="/static/image/mini_qr.jpg" class="qr-img" />
              </div>
              <span class="qr-label">小程序</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Filing Info -->
      <div class="footer-filing">
        <div class="filing-row">
          <a href="https://beian.miit.gov.cn/" target="_blank" class="filing-link">蜀ICP备2024085443号-1</a>
          <span class="filing-sep">|</span>
          <a href="https://beian.mps.gov.cn/#/query/webSearch/" target="_blank"
            class="filing-link">川公网安备51011402000838号</a>
          <span class="filing-sep">|</span>
          增值电信业务经营许可证编号：川B2-20250053
          <span class="filing-sep">|</span>
          互联网药品信息服务资格证书编号：（川）-经营性-2024-0050
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainData: null,
    };
  },
  created() {
    this.wjtHttp.get(this, "/api/home/v1/info", {}, false, (res) => {
      var data = res.data;
      if (data.code == 200) {
        this.mainData = data.data;
        this.mainData.email = "scbaicaojiankang@163.com";
        this.mainData.phone = "028-89275987";
        this.mainData.address =
          "四川省成都市新都区大丰街道敬成路99号3栋附409号";
      } else {
        this.$message({
          message:
            data.msg && data.msg.length > 0
              ? data.msg
              : "信息获取异常，请联系管理员",
          type: "error",
        });
      }
    });
  },
  methods: {
    goLink(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.footer-container {
  position: relative;
  width: 100%;
  padding: 56px 0 24px;
  overflow: hidden;
  background: #f8faf9;
}

.footer-bg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.footer-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
  opacity: 0.35;
}

.footer-inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}

/* ── 3-Column Grid ── */
.footer-grid {
  display: grid;
  grid-template-columns: 3fr 1fr 1.2fr;
  gap: 48px;
  padding: 0 50px;
  margin-bottom: 40px;
}

.footer-col {
  min-width: 0;
  text-align: left;
}

.footer-heading {
  font-size: 24px;
  font-weight: 600;
  color: #20863F;
  margin: 0 0 18px 0;
}

/* ── Brand ── */
.footer-brand .brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.brand-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.brand-cn {
  font-size: 18px;
  font-weight: bold;
  color: #1a1a1a;
  letter-spacing: 1px;
}

.brand-en {
  font-size: 9px;
  color: #888;
  letter-spacing: 2px;
}

.brand-company {
  font-size: 24px;
  font-weight: 600;
  color: #20863F;
  margin: 0 0 10px 0;
}

.brand-info {
  font-size: 17px;
  color: #666;
  line-height: 1.9;
  margin: 0;
}

/* ── Compliance ── */
.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  font-size: 20px;
  font-weight: 500;
  text-decoration: none;
  color: #000000;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #20863F;
}

/* ── QR Codes ── */
.footer-qr {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.qr-row {
  display: flex;
  gap: 20px;
}

.qr-item {
  text-align: center;
}

.qr-box {
  width: 120px;
  height: 120px;
  background: #e8e8e8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  overflow: hidden;
}

.qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-label {
  font-size: 16px;
  color: #555;
}

/* ── Filing ── */
.footer-filing {
  position: relative;
  z-index: 1;
  padding-top: 0px;
  /* border-top: 1px solid rgba(0, 0, 0, 0.06); */
}

.filing-row {
  font-size: 13px;
  color: #888;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 16px;
}

.filing-link {
  color: #888;
  text-decoration: none;
}

.filing-link:hover {
  color: #20863F;
}

.filing-sep {
  color: #ccc;
}

/* ── Responsive: Tablet (<=1024px) ── */
@media screen and (max-width: 1024px) {
  .footer-inner {
    padding: 0 24px;
  }

  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }

  .footer-qr {
    justify-content: flex-start;
  }

  .filing-row {
    font-size: 12px;
  }
}

/* ── Responsive: Mobile (<=640px) ── */
@media screen and (max-width: 640px) {
  .footer-container {
    padding: 36px 0 16px;
  }

  .footer-inner {
    padding: 0 16px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 28px;
    margin-bottom: 28px;
  }

  .footer-col {
    text-align: center;
  }

  .footer-brand .brand-row {
    justify-content: center;
  }

  .footer-qr {
    justify-content: center;
  }

  .footer-heading {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .footer-links li {
    margin-bottom: 8px;
  }

  .brand-info {
    font-size: 12px;
  }

  .filing-row {
    font-size: 11px;
    line-height: 1.8;
  }
}
</style>
